import React from 'react';
import { compose } from 'redux';
import AppMenuMain from './AppMenuMain';
import PropTypes from 'prop-types';
import AppToolbar from './AppToolbar';
import { connect } from 'react-redux';
import AppMenuAccount from './AppMenuAccount';
import { MainMenuConfig } from './menu/MainMenuConfig';
import { updateMenuWithApiAccess } from './menu/MenuUtils';

const AppControls = ({ controlsVisible, endpointAccess }) => {
  const [showDrawer, setShowDrawer] = React.useState(false);
  const [showMenu, setShowMenu] = React.useState(null);
  const [menuWithEndpointStatus, setMenuWithEndpointStatus] = React.useState([]);
  
  React.useEffect(() => {
    if (endpointAccess) {
      const updatedMenu = updateMenuWithApiAccess(MainMenuConfig, endpointAccess);
      setMenuWithEndpointStatus(updatedMenu);
    }
  }, [endpointAccess]);
  
  React.useEffect(() => {
    setShowDrawer(false);
    setShowMenu(null);
  }, [controlsVisible]);
  
  return (
    <React.Fragment>
      {controlsVisible &&
      <AppMenuMain
        open={showDrawer}
        menuDefinition={endpointAccess ? menuWithEndpointStatus : MainMenuConfig}
        onClose={() => {
          setShowDrawer(false);
        }}
      />}
      
      <AppToolbar
        visible={controlsVisible}
        onShowMainMenu={() => {
          setShowDrawer(true);
        }}
        onShowAccountMenu={({ currentTarget }) => {
          setShowMenu(currentTarget);
        }}
      />
      
      <AppMenuAccount
        openFor={showMenu}
        onClose={() => {
          setShowMenu(null);
        }}
      />
    </React.Fragment>
  );
};

AppControls.propTypes = {
  controlsVisible: PropTypes.bool,
  endpointAccess: PropTypes.array,
};

const decorate = compose(
  connect(
    store => ({
      endpointAccess: store.user.endpointAccess,
    }),
    null),
);

export default decorate(AppControls);